/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
export const WebhookIcon = ({size, ...props}) => (
  <svg viewBox="0 0 28 28" fill="currentColor" width={ size || "28" } height={ size || "28" } {...props}>
    <g fill="none">
      <g transform="translate(1.67 16.274)">
        <circle cx="20" cy="4.465" r="2" fill="#162D3D" />
        <path fill="#162D3D" d="M8.96 4.91h1.25a5 5 0 1 1-7-4.584v1.412A3.75 3.75 0 1 0 8.96 4.91z" />
        <path stroke="#162D3D" d="M19 4.465H9.462" />
      </g>
      <g transform="rotate(-120 17.96 8.048)">
        <circle cx="20" cy="4.465" r="2" fill="#162D3D" />
        <path fill="#162D3D" d="M8.96 4.948h1.25a5 5 0 1 1-7-4.584v1.411a3.75 3.75 0 1 0 5.75 3.173z" />
        <path stroke="#162D3D" d="M19 4.465H9.462" />
      </g>
      <g transform="rotate(120 8.69 9)">
        <circle cx="20" cy="4.465" r="2" fill="#162D3D" />
        <path fill="#162D3D" d="M8.962 4.935h1.25a5 5 0 1 1-7-4.584v1.411a3.75 3.75 0 1 0 5.75 3.173z" />
        <path stroke="#162D3D" d="M19 4.465H9.462" />
      </g>
    </g>
  </svg>
);
WebhookIcon.displayName = 'WebhookIcon';
WebhookIcon.propTypes = {
  size: PropTypes.string
}
/* tslint:enable */
/* eslint-enable */
